<div class="form-group" [class.small]="size === 'small'">
  <div
    class="row file-upload-container"
    [class.success]="selectedImage && !warning && !isDragged"
    [class.warning]="warning && !isDragged"
    [class.dragged]="isDragged"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()">
    <div class="image-preview" [class.small]="size === 'small'">
      <ng-container *ngIf="isDragged; else notDragged">
        <yat-icon id="9d444d05-4314-4bbf-b62c-c867a3172172" name="cloud-upload" title="Upload"></yat-icon>
        <span class="c-gray">Image</span>
      </ng-container>
      <ng-template #notDragged>
        <yat-icon id="e5af3b63-fa72-47f3-bc40-6959307263c0" *ngIf="warning" name="warning-duo" title="Upload"></yat-icon>
        <yat-icon id="73c49e18-cd7a-45b1-be17-6b9a5412f8d2" *ngIf="!warning && !selectedImage" name="cloud-upload" title="Upload"></yat-icon>
        <img *ngIf="selectedImage" [src]="selectedImage | safeUrl : 'image'" alt="" />
        <ng-container *ngIf="warning" [ngSwitch]="warning">
          <span *ngSwitchCase="'wrongFileType'" class="c-gray">File</span>
          <span *ngSwitchCase="'maxFileSizeExceeded'" class="c-gray">Size</span>
        </ng-container>
        <ng-container *ngIf="!warning && !selectedImage">
          <span class="c-gray">Image</span>
        </ng-container>
      </ng-template>
    </div>

    <ng-container *ngIf="!previewOnly">
      <span *ngIf="!filename && !warning" class="c-gray upload-description">
        Drag & drop here or
        <ng-container *ngIf="!displayWide">
          <br />
        </ng-container>
        <a yat-link class="link link-primary link-large" [routerLink]="null" (blur)="onTouched()">select file</a> to upload.
        <br />
        <span class="extension"> {{ fileTypes | describeFileExtension : 'dot' }} | max {{ maxFileSize }} MB </span>
      </span>

      <span *ngIf="filename && !warning" class="c-gray upload-description">
        <a yat-link class="link link-primary link-large" [routerLink]="null" (blur)="onTouched()">Select new file</a> to upload.
        <br />
        <span class="extension">{{ filename }}</span>
      </span>

      <span *ngIf="warning" class="c-gray upload-description">
        <a yat-link class="link link-primary link-large" [routerLink]="null" (blur)="onTouched()">Select new file</a> to upload.
        <br />
        <ng-container [ngSwitch]="warning">
          <span *ngSwitchCase="'wrongFileType'" class="extension">Select a {{ fileTypes | describeFileExtension : 'comma-or' }} file.</span>
          <span *ngSwitchCase="'maxFileSizeExceeded'" class="extension">Sorry, the max file size is {{ maxFileSize }}MB.</span>
        </ng-container>
      </span>
    </ng-container>

    <input
      #fileInput
      type="file"
      hidden
      [accept]="fileExtensions | describeFileExtension : 'input-accept'"
      (change)="selectFileFromEventTarget($event.target)" />
  </div>
</div>
